module.exports = __webpack_public_path__ + "img/ECC.238d5b58.png";